// Shopify confirmation URLs open in the merchant's admin, so the auth session
// needs to survive the leave-and-return trip. Mirror the brand token across
// localStorage and sessionStorage before redirecting.
export function redirectToShopify(confirmationUrl: string): void {
  const currentToken =
    localStorage.getItem('brand_token') ||
    localStorage.getItem('brand_temp_token');

  if (currentToken) {
    localStorage.setItem('brand_token', currentToken);
    localStorage.setItem('brand_temp_token', currentToken);
    sessionStorage.setItem('brand_token', currentToken);
    sessionStorage.setItem('brand_temp_token', currentToken);

    const userData = localStorage.getItem('brand_user');
    if (userData) {
      sessionStorage.setItem('brand_user', userData);
    }
  }

  window.location.href = confirmationUrl;
}
